/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

import ReviewerProfile from '../../../reviewing/ReviewerProfile'

import { positionChangeWidthSm } from '../../../../helpers/variableDefaults'
import { exitModalIconButton } from '../../../../helpers/buttons'

export const fullReviewerProfileModalJSX = (isDemo, demoUser, profileType, reviewerProfileToView, setReviewerProfileToView, openFullReviewerProfileModal, setOpenFullReviewerProfileModal, width) => {

  // console.log('reviewerProfileToView ->', reviewerProfileToView)

  const handleFullReviewerProfileModalClose = () => {
    // console.log('handleFeedbackInfoModalClose runs ->')
    // console.log('open ->', open)

    setReviewerProfileToView({})
    setOpenFullReviewerProfileModal(false)
  }

  return (
    <Modal
      open={openFullReviewerProfileModal}
      onClose={handleFullReviewerProfileModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box 
        sx={{ 
          // position: 'absolute',
          // left: '50%',
          // top: '50%',
          // transform: 'translate(-50%, -50%)',
          // width: width < positionChangeWidthSm ? '85%' : '450px',
          width: width >= positionChangeWidthSm ? '85%' : '95%',
          height: width >= positionChangeWidthSm ? '85%' : '85%',
          bgcolor: 'white',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4, 
          overflowY: 'scroll',
          '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '4px',
            backgroundColor: 'rgba(0, 0, 0, .35)',
            webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
          },
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        {/* Exit Icon Button */}
        <Box
          sx={{
            position: width < positionChangeWidthSm ? 'inherit' : 'absolute',
            top: width < positionChangeWidthSm ? '0px' : '10%', left: width < positionChangeWidthSm ? '0px' : '37%',
            // mr: 0, mb: 1,
            width: '100%',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {exitModalIconButton(handleFullReviewerProfileModalClose, false, 0, 1, 1)}
        </Box>

        {/* {console.log('reviewerProfileToView ->', reviewerProfileToView)} */}

        {/* Reviewer Profile */}
        <ReviewerProfile 
          reviewerProfileObj={reviewerProfileToView} 
          isDemo={isDemo} 
          demoUser={demoUser} 
          profileType={profileType} 
          reviewerFirstName={reviewerProfileToView.bio.vitalInfo.firstName.toLowerCase().replace(/ /g,'')} 
        />


      </Box>
    </Modal>
  )
}